module.exports = __webpack_public_path__ + "static/media/lotus-go-drive.31262ec4.png";